var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIconV2(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14.08C14.74 14.08 14.06 14.38 13.54 14.85L6.41 10.7C6.46 10.47 6.5 10.24 6.5 10C6.5 9.76 6.46 9.53 6.41 9.3L13.46 5.19C14 5.69 14.71 6 15.5 6C17.16 6 18.5 4.66 18.5 3C18.5 1.34 17.16 0 15.5 0C13.84 0 12.5 1.34 12.5 3C12.5 3.24 12.54 3.47 12.59 3.7L5.54 7.81C5 7.31 4.29 7 3.5 7C1.84 7 0.5 8.34 0.5 10C0.5 11.66 1.84 13 3.5 13C4.29 13 5 12.69 5.54 12.19L12.66 16.35C12.61 16.56 12.58 16.78 12.58 17C12.58 18.61 13.89 19.92 15.5 19.92C17.11 19.92 18.42 18.61 18.42 17C18.42 15.39 17.11 14.08 15.5 14.08Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIconV2);
export default __webpack_public_path__ + "static/media/ShareIconV2.48b0e12c63b24c56ee2a850f27872e1f.svg";
export { ForwardRef as ReactComponent };